export default class FootnoteHelper {
  static updateFootnoteSymbols = (oldFootnoteMap) => {
    const newFootnoteMap = new Map();
    ['numeric', 'star'].forEach((v) => updateNotesForVariant(oldFootnoteMap, newFootnoteMap, v));
    return newFootnoteMap;
  };
}

const updateNotesForVariant = (oldMap, newMap, variant) => {
  const variantNotes = [...oldMap.values()].filter((f) => f.variant === variant).sort((a, b) => (a.id < b.id ? -1 : 1));
  const processedVariantNotes = noteVariantAssignment[variant](variantNotes);
  processedVariantNotes.forEach((n) => newMap.set(n.id, n));
};

const noteVariantAssignment = {
  numeric: (noteObjList) => noteObjList.map((o, index) => ({ ...o, symbol: index + 1 })),
  star: (noteObjList) => noteObjList.map((o, index) => ({ ...o, symbol: '*'.repeat(index + 1) })),
};
